/*
 * @FilePath: /src/router/index.js
 * @Description: 路由文件
 */
import Vue from 'vue'
import Router from 'vue-router'
// import HelloWorld from '@/components/HelloWorld'
import HomeView from '@/views/home.vue'
import AboutView from '@/views/about.vue'
import NewsView from '@/views/news.vue'
import JoinView from '@/views/join.vue'
import ContactView from '@/views/contact.vue'

Vue.use(Router)

const originaReplace = Router.prototype.replace
Router.prototype.replace = function replace(location) {
  return originaReplace.call(this, location).catch((err) => err)
}
export default new Router({
  routes: [
    // {
    //   path: '/',
    //   name: 'HelloWorld',
    //   component: HelloWorld
    // }
    {
      path: '/',
      name: 'homeView',
      component: HomeView
    },
    {
      path: '/about',
      name: 'about',
      component: AboutView
    },
    {
      path: '/news',
      name: 'news',
      component: NewsView
    },
    {
      path: '/join',
      name: 'join',
      component: JoinView
    },
    {
      path: '/contact',
      name: 'contact',
      component: ContactView
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js